import React from 'react';

import {
    filterContainer,
    filterList,
    filterTitle,
    loader,
    filterWrapper,
    sortTitle,
    sortIcon,
    sortWrapper,
    noTitle,
} from './filters.module.scss';
import SortIcon from '../../../assets/images/svg/icon-sort.svg';
import useGenericFilters, { IUseGenericFilterProps } from '../../../hooks/use-generic-filters';

import FilterList from '../../molecules/filter-molecules/filter-list';

export interface IFiltersProps extends IUseGenericFilterProps {
    className?: string;
    filterClassName?: string;
    filterListClassName?: string;
    loading?: boolean;
    showTitle?: boolean;
}

const Filters = ({
    className = '',
    filterClassName = '',
    filterListClassName = '',
    loading,
    showTitle = true,
    ...filterProps
}: IFiltersProps) => {
    const {
        filtersCollection,
        sortCollection,
        openedItem,
        toggleOpen,
        applyFilters,
        filterClear,
        filterClick,
        sortClick,
    } = useGenericFilters(filterProps);

    return (
        <form
            className={`${filterContainer} ${className} ${loading ? loader : ''} ${
                showTitle ? '' : noTitle
            }`}
        >
            {Object.entries(filtersCollection).length > 0 && (
                <div className={filterWrapper}>
                    {showTitle && <div className={filterTitle}>Filtry:</div>}
                    <ul className={`${filterList} ${filterListClassName}`}>
                        <FilterList
                            items={filtersCollection}
                            itemProps={{
                                openedItem,
                                applyFilters,
                                clear: filterClear,
                                handleOpen: toggleOpen,
                                filterClick,
                                className: filterClassName,
                            }}
                        />
                    </ul>
                </div>
            )}

            {Object.values(sortCollection)?.length > 0 && (
                <div className={sortWrapper}>
                    <div className={sortTitle}>
                        <SortIcon className={sortIcon} />
                        <div className={filterTitle}>Sortuj:</div>
                    </div>
                    <ul className={filterList}>
                        <FilterList
                            items={sortCollection}
                            itemProps={{
                                openedItem,
                                clear: filterClear,
                                handleOpen: toggleOpen,
                                filterClick: sortClick,
                                withButtons: false,
                                showApplied: true,
                                className: filterClassName,
                            }}
                        />
                    </ul>
                </div>
            )}
        </form>
    );
};

export default Filters;
